import React from 'react';
import OpenOnDeviceButton from './open-on-device-button';
import { useTranslator } from 'static/script/app/lang';

const BankIdStart = ({ children, isAutoStartAllowed, autoStartToken }) => {
    const { t } = useTranslator();
    return (
        <div className="receipt align-center">
            <img
                src="/static/images/bankid/bankid.svg"
                className="payments-settings-bankid mb-1"
            />
            <h1 className="h4 font-weight-bold mt-4">
                {t('bankIdModal_StartTitle')}
            </h1>
            {children}
            <OpenOnDeviceButton
                isAutoStartAllowed={isAutoStartAllowed}
                autoStartToken={autoStartToken}
            />
        </div>
    );
};
export default BankIdStart;
